import { EnumType } from './types';
import { keys } from './utils';

export const awsS3Url = (fileName: string) =>
  `https://www.kaaja.com/upload/${fileName}`;

export const externalUrl = ({src}: {src: string}) => src;

export type LOCALE = 'en' | 'it';

export const AUCTION_STATUSES = {
  COMING_SOON: 'coming_soon',
  CREATED: 'created',
  BUY_NOW_UNDER_EVALUATION: 'buy_now_under_evaluation',
  BUY_NOW_ONLY_UNDER_EVALUATION: 'buy_now_only_under_evaluation',
  RUNNING: 'running',
  CLOSED_WITH_NO_BIDS: 'closed_with_no_bids',
  CLOSED_WITH_WINNER_AND_RESERVED_PRICE_NOT_MET:
    'closed_with_winner_and_reserved_price_not_met',
  CLOSED_WITH_WINNER_AND_RESERVED_PRICE_MET:
    'closed_with_winner_and_reserved_price_met',
  SOLD_FOR_BUY_NOW: 'sold_for_buy_now',
  SOLD: 'sold',
  ONLY_BUY_NOW: 'only_buy_now',
  UNDER_EVALUATION: 'under_evaluation',
  NOT_SOLD: 'not_sold',
} as const;

export const AUCTION_STATUSES_CLOSED = [
  AUCTION_STATUSES.CLOSED_WITH_NO_BIDS,
  AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_MET,
  AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_NOT_MET,
  AUCTION_STATUSES.SOLD,
  AUCTION_STATUSES.SOLD_FOR_BUY_NOW,
  AUCTION_STATUSES.NOT_SOLD,
  AUCTION_STATUSES.UNDER_EVALUATION,
  AUCTION_STATUSES.BUY_NOW_UNDER_EVALUATION,
  AUCTION_STATUSES.BUY_NOW_ONLY_UNDER_EVALUATION,
] as const;

export const AUCTION_STATUSES_HIDE_PIN_PRICE = [
  AUCTION_STATUSES.CLOSED_WITH_NO_BIDS,
  AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_MET,
  AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_NOT_MET,
  AUCTION_STATUSES.SOLD,
  AUCTION_STATUSES.SOLD_FOR_BUY_NOW,
  AUCTION_STATUSES.NOT_SOLD,
] as const;

export type AuctionStatus = EnumType<typeof AUCTION_STATUSES>;

export const DEPOSIT_PAYMENT_STATUS = {
  CREATED_OR_FAILED: 'requires_payment_method',
  OPTIONAL_CONFIRMATION_NEEDED: 'requires_confirmation',
  OPTIONAL_OTP_ACTION_NEEDED: 'requires_action',
  CAPTURE_NEEDED: 'requires_capture',
  SUCCEEDED: 'succeeded',
} as const;

export type DepositPaymentStatus = EnumType<typeof DEPOSIT_PAYMENT_STATUS>;

export const PERSONAL_AREA_MENU_ITEMS = {
  ACCOUNT: 'ACCOUNT',
  FAVORITES: 'FAVORITES',
  AUCTION_WHERE_I_AM_INVOLVED: 'AUCTION_WHERE_I_AM_INVOLVED',
};

export const VISIT_BOOKING_CREATION_MODE = Object.freeze({
  CHOOSE_DATE_AND_TIME: 1,
  COMPILE_FORM: 2,
  RECAP_FORM: 3,
  BOOKING_COMPLETED: 4,
} as const);
export type VisitBookingCreationMode = EnumType<
  typeof VISIT_BOOKING_CREATION_MODE
>;

export const VISIT_BOOKING_CREATION_WIDGET_MODE = Object.freeze({
  CHOOSE_DATE_AND_TIME: 1,
  VISIT_TYPE: 2,
  COMPILE_FORM: 3,
  RECAP_FORM: 4,
  BOOKING_COMPLETED: 5,
} as const);
export type VisitBookingCreationWidgetMode = EnumType<
  typeof VISIT_BOOKING_CREATION_WIDGET_MODE
>;

export const VISIT_BOOKING_EDITING_MODE = Object.freeze({
  CHOOSE_DATE_AND_TIME: 1,
  RECAP_FORM: 2,
  BOOKING_COMPLETED: 3,
} as const);
export type VisitBookingEditingMode = EnumType<
  typeof VISIT_BOOKING_EDITING_MODE
>;

export enum SrpType {
  LOCATION_REGION,
  LOCATION_PROVINCE,
  LOCATION_CITY,
}

export enum PdpModes {
  PDP,
  BID_STEPPER,
  BUY_NOW_STEPPER,
  BUY_NOW_STEPPER_WITH_INFO,
  DESCRIPTION,
  BID_LIST,
  VISIT_BOOKING_CREATION,
  VISIT_BOOKING_EDITING,
}

export enum SrpModes {
  SRP,
  MAP,
  ORDER,
  FILTER,
}

export enum StepperViewMode {
  STANDALONE,
  SIDE_PROCESS,
}

export const LABELS_LENGTH = {
  PROPERTY_LIST_ITEM_TITLE: 60,
  PROPERTY_LIST_ITEM_ZONE: 35,
  IMMOBILE_METADATA_DESCRIPTION_LENGHT: 200,
};

export const PDP_VISIT_TYPES = {
  IN_PERSON_VISIT: 'in_person_visit',
  VIRTUAL_VISIT: 'virtual_visit',
  OPEN_HOUSE_VISIT: 'open_house_visit',
  TOUR_VISIT: '360_tour_visit',
} as const;
export type PdpVisitTypes = EnumType<typeof PDP_VISIT_TYPES>;

export type VisitBookingTypes = Extract<
  PdpVisitTypes,
  'in_person_visit' | 'virtual_visit'
>;

const VISIT_BOOKING: Record<VisitBookingTypes, null> = {
  [PDP_VISIT_TYPES.IN_PERSON_VISIT]: null,
  [PDP_VISIT_TYPES.VIRTUAL_VISIT]: null,
};
export const VISIT_BOOKING_TYPES = keys(VISIT_BOOKING);

export const VISIT_BOOKING_PERIODS = 30;

export enum PaymentMethod {
  CreditCard = 'card',
  SEPA = 'sepa_debit',
}

export type WidgetTab = 'booking-visit' | 'buy' | 'docs' | 'contact';

export type WidgetView =
  | 'booking-visit'
  | 'booking-view'
  | 'contact'
  | 'buy'
  | 'buy-in-progress'
  | 'bid-list'
  | 'sign-in'
  | 'sign-up'
  | 'forgot-password'
  | 'docs';
